export default __webpack_public_path__ + "static/media/helmet.e31a53e4.svg";